// processモジュールの代わりに、環境変数に直接アクセス
// import process from "process"; // この行を削除
/**
 *
 * KronoMetro
 *
 * Copyright © 2019-present KronoMetro, Co. All rights reserved.
 *
 * 注意：env ファイルで読み込みは使わないこと
 *
 */

/**
 * 環境変数の追加方法:
 * 1. turbo.jsonのglobalEnvに新しい環境変数名を追加
 * 2. env/.env.* の各環境設定ファイルに環境変数を追加
 * 3. 以下のprocess.envから取得する変数リストに追加
 */
const config = {
  ENVIRONMENT: process.env.ENVIRONMENT,
  BASE_URL: process.env.BASE_URL,
  PORT: process.env.PORT,
  LOG_LEVEL: process.env.LOG_LEVEL,
  SESSION_SECRET: process.env.SESSION_SECRET,

  // アプリケーション識別を追加
  APP_NAME: process.env.APP_NAME || "webapp",

  // アプリケーション別の設定
  app: {
    www: {
      BASE_URL: process.env.WWW_BASE_URL || process.env.BASE_URL,
      PORT: process.env.WWW_PORT || process.env.PORT || 3000,
      LOG_LEVEL: process.env.WWW_LOG_LEVEL || process.env.LOG_LEVEL,
      SESSION_SECRET: process.env.WWW_SESSION_SECRET || process.env.SESSION_SECRET,
      SESSION_MAX_AGE: process.env.WWW_SESSION_MAX_AGE || process.env.SESSION_MAX_AGE || 7200,
      SESSION_TOKEN_NAME: process.env.WWW_SESSION_TOKEN_NAME || process.env.SESSION_TOKEN_NAME || "kronometro_session_token",
      CALLBACK_URL_NAME: process.env.WWW_CALLBACK_URL_NAME || process.env.CALLBACK_URL_NAME || "kronometro_callback_url",
      CSRF_TOKEN_NAME: process.env.WWW_CSRF_TOKEN_NAME || process.env.CSRF_TOKEN_NAME || "kronometro_csrf_token",
      sequelize: {
        database: process.env.WWW_DATABASE || process.env.DATABASE,
        user: process.env.WWW_DB_USER || process.env.DB_USER,
        pass: process.env.WWW_DB_PASS || process.env.DB_PASS,
        config: {
          dialect: process.env.WWW_DB_DIALECT || process.env.DB_DIALECT,
          host: process.env.WWW_DB_HOST || process.env.DB_HOST,
        },
      },
      amazon: {
        Metrojs: {
          region_code: process.env.WWW_ASES_REGION_CODE || process.env.ASES_REGION_CODE,
          cred_key: process.env.WWW_ASES_CREDENTIAL_ACCESS_KEY || process.env.ASES_CREDENTIAL_ACCESS_KEY,
          secret_key: process.env.WWW_ASES_CREDENTIAL_SECRET_KEY || process.env.ASES_CREDENTIAL_SECRET_KEY,
          S3_cred_key: process.env.S3_CREDENTIAL_ACCESS_KEY,
          S3_secret_key: process.env.S3_CREDENTIAL_SECRET_KEY,
          S3_image_folder: process.env.S3_IMAGE_FOLDER,
          S3_image_folder_direct: process.env.S3_IMAGE_FOLDER_DIRECT,
          from_address: process.env.WWW_ASES_FROM_ADDRESS || process.env.ASES_FROM_ADDRESS,
          queue_url: process.env.WWW_SQS_QUEUE_URL || process.env.SQS_QUEUE_URL,
          bucket_name: process.env.WWW_S3_BUCKET_NAME || process.env.S3_BUCKET_NAME,
        },
      },
    },
    seller: {
      BASE_URL: process.env.SELLER_BASE_URL,
      PORT: process.env.SELLER_PORT || 3001,
    },
    buyer: {
      BASE_URL: process.env.BUYER_BASE_URL,
      PORT: process.env.BUYER_PORT || 3002,
    },
    admin: {
      BASE_URL: process.env.ADMIN_BASE_URL,
      PORT: process.env.ADMIN_PORT || 3003,
    },
  },

  sequelize: {
    database: process.env.DATABASE,
    user: process.env.DB_USER,
    pass: process.env.DB_PASS,
    config: {
      dialect: process.env.DB_DIALECT,
      host: process.env.DB_HOST,
      pool: {
        // 接続プール構成を後処理する
        max: 20, // プール内の最大接続数を増加（10 → 20）
        min: 2, // プール内の最小接続数を増加（0 → 2）
        acquire: 120000, // 接続取得タイムアウトを延長（30000 → 60000: 30秒 → 60秒）
        idle: 30000, // アイドルタイムアウトを延長（20000 → 30000: 20秒 → 30秒）
        evict: 60000, // 接続の強制削除間隔を設定（60秒）
        waitForConnections: true,
        queueLimit: 0,
      },
      dialectOptions: {
        insecureAuth: false, // 安全でない認証を許可する
        // 接続タイムアウトの追加設定
        connectTimeout: 60000, // 接続タイムアウト（60秒）
        enableKeepAlive: true,
        keepAliveInitialDelay: 10000,
        dateStrings: true, // 日付をdatetime型ではなく文字列で返す
        typeCast: true, // 型変換を有効にする
      },
      insecureAuth: false, // 安全でない認証を許可する
      timezone: "+09:00", // タイムゾーンを日本時間に設定
      /* logging: false*/
      //クエリのモデル定義がない場合は、これをtrueに設定します。
      //raw: true,
      // Sequelize のクエリ再試行
      retry: {
        match: [
          /ETIMEDOUT/,
          /ECONNRESET/,
          /SequelizeConnectionError/,
          /SequelizeConnectionRefusedError/,
          /SequelizeHostNotFoundError/,
          /SequelizeHostNotReachableError/,
          /SequelizeInvalidConnectionError/,
          /SequelizeConnectionTimedOutError/,
        ],
        max: 3,
      },
    },
  },
  // セッション関連の設定
  SESSION_MAX_AGE: process.env.SESSION_MAX_AGE || 7200, // 2時間
  SESSION_TOKEN_NAME: process.env.SESSION_TOKEN_NAME || "kronometro_session_token",
  CALLBACK_URL_NAME: process.env.CALLBACK_URL_NAME || "kronometro_callback_url",
  CSRF_TOKEN_NAME: process.env.CSRF_TOKEN_NAME || "kronometro_csrf_token",

  // ASES・ASQSの設定
  amazon: {
    Metrojs: {
      region_code: process.env.ASES_REGION_CODE,
      cred_key: process.env.ASES_CREDENTIAL_ACCESS_KEY,
      secret_key: process.env.ASES_CREDENTIAL_SECRET_KEY,
      S3_cred_key: process.env.S3_CREDENTIAL_ACCESS_KEY,
      S3_secret_key: process.env.S3_CREDENTIAL_SECRET_KEY,
      S3_image_folder: process.env.S3_IMAGE_FOLDER,
      S3_image_folder_direct: process.env.S3_IMAGE_FOLDER_DIRECT,
      from_address: process.env.ASES_FROM_ADDRESS,
      queue_url: process.env.SQS_QUEUE_URL,
      bucket_name: process.env.S3_BUCKET_NAME,
      expires: 60 * 5, // 5分間
      timeout: 10000, // 10秒
    },
    // 追加ユーザがある場合はここに追加
  },

  // DirectOrder URL設定
  // NEXT_PUBLIC_プレフィックス付きの環境変数を優先（クライアントサイドでも使用可能）
  // フォールバックとして通常の環境変数も使用可能
  DO_AB_URL: process.env.NEXT_PUBLIC_DO_AB_URL || process.env.DO_AB_URL || "",
  DO_YZ_URL: process.env.NEXT_PUBLIC_DO_YZ_URL || process.env.DO_YZ_URL || "",
};
/**
 * アプリケーション別の設定を取得
 * @param {string} key - 設定キー
 * @returns {any} 設定値
 */
const getAppConfig = (key) => {
  const appName = config.APP_NAME;
  const appConfig = config.app[appName];

  console.log(`getAppConfig appName:${appName} key:${key}`);
  console.dir({ appName, key, appConfig }, { depth: null }); // thisの代わりに具体的なオブジェクトを指定
  if (appConfig && appConfig[key] !== undefined) {
    return appConfig[key];
  }

  // アプリケーション固有の設定がない場合はグローバル設定を返す
  return config[key];
};
// 設定オブジェクトに動的取得関数を追加
config.getAppConfig = getAppConfig;

export default config;
